module.exports = __webpack_public_path__ + "media/assets/images/app/Landing/WhyUs__carousel__2-a5451de897501b8b8f7f4f70d78f8227.jpg";